const moduleFiles = import.meta.glob('./*.js', { eager: true });
const modules = {};

Object.entries(moduleFiles).forEach(([path, module]) => {
  if (path === './index.js') {
    return;
  }

  modules[path.replaceAll('./', '').replaceAll('.js', '')] = module.default;
});

export default modules;
